// @flow
import * as React from 'react'
import moment from 'moment'
import { FormattedMoment } from 'mz-intl'
import CalendarIcon from 'mz-icons/calendar'
import { LightboxBaseField } from '../../../core/LightboxBaseField'
import DesktopDateLightbox from './Lightbox'
import { getDateFormat } from '../utils'

// Types
import type {
  Props as BaseFieldProps,
  Input as InputProps,
} from '../../../core/BaseField'
import type { AppearanceTitle } from '../../../core/Lightbox'

export type Props = BaseFieldProps & {
  input: InputProps,
  minDate?: Date,
  maxDate?: Date,
  dateFormat?: string,
  disableTime?: boolean,
  lightboxTitle?: AppearanceTitle,
  lightboxSubtitle?: AppearanceTitle,
}

/**
 * Desktop version of date selector.
 */
class DesktopDateField extends React.Component<Props> {
  static defaultProps = {
    input: {},
    meta: {},
    disableTime: true,
  }

  renderLightbox = ({ cancel, select, setFocusableRef }: *) => {
    return (
      <DesktopDateLightbox
        input={this.props.input}
        minDate={this.props.minDate}
        maxDate={this.props.maxDate}
        onCancel={cancel}
        onSelect={select}
        setFocusableRef={setFocusableRef}
      />
    )
  }

  renderValue = (value: ?moment, render: *) => {
    const { disableTime, dateFormat } = this.props
    return (
      <FormattedMoment
        value={value}
        format={getDateFormat(!!disableTime, dateFormat)}
      >
        {render}
      </FormattedMoment>
    )
  }

  render() {
    return (
      <LightboxBaseField
        {...this.props}
        renderPrefix={() => <CalendarIcon />}
        renderValue={this.renderValue}
        renderLightbox={this.renderLightbox}
        emptyValue={null}
      />
    )
  }
}

export default DesktopDateField
